import { BaseFilterParams } from 'dashboard/lib/interfaces/BaseFilterParams';
import { UserAuditLog, UserAuditLogAttributes } from 'dashboard/models/user-audit-log';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';

export interface UserAuditLogsFilterParams extends BaseFilterParams {
  userId?: string;
  methods?: UserAuditLogAttributes['method'][];
}

export type UserAuditLogsActions =
  | Action<UserAuditLogsActionType.SetUserAuditLogs, SetUserAuditLogsPayload>
  | Action<UserAuditLogsActionType.SetFilters, SetFiltersPayload>
  | Action<UserAuditLogsActionType.SetCurrentPage, SetCurrentPagePayload>
  | Action<UserAuditLogsActionType.SetPageSize, SetPageSizePayload>;

export enum UserAuditLogsActionType {
  SetUserAuditLogs = 'user-audit-logs/SET_USER_AUDIT_LOGS',
  SetFilters = 'user-audit-logs/SET_FILTERS',
  SetCurrentPage = 'user-audit-logs/SET_CURRENT_PAGE',
  SetPageSize = 'user-audit-logs/SET_PAGE_SIZE',
}

interface SetUserAuditLogsPayload {
  userAuditLogs: UserAuditLog[];
  paginationParams: PaginationParams;
}

export function setUserAuditLogs(
  userAuditLogs: UserAuditLog[],
  paginationParams: PaginationParams,
) {
  return {
    payload: {
      userAuditLogs,
      paginationParams,
    },
    type: UserAuditLogsActionType.SetUserAuditLogs,
  };
}

interface SetFiltersPayload {
  filters: UserAuditLogsFilterParams;
}

export function setFilters(filters: UserAuditLogsFilterParams) {
  return {
    payload: {
      filters,
    },
    type: UserAuditLogsActionType.SetFilters,
  };
}

interface SetCurrentPagePayload {
  currentPage: number;
}

export function setCurrentPage(currentPage: number) {
  return {
    payload: {
      currentPage,
    },
    type: UserAuditLogsActionType.SetCurrentPage,
  };
}

interface SetPageSizePayload {
  pageSize: number;
}

export function setPageSize(pageSize: number) {
  return {
    payload: {
      pageSize,
    },
    type: UserAuditLogsActionType.SetPageSize,
  };
}
